(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/hooks/assets/javascripts/use-examine-player-wager.js') >= 0) return;  svs.modules.push('/components/pool-betting/hooks/assets/javascripts/use-examine-player-wager.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect;
const getLogger = svs.core.log.getLogger;
const useExaminePlayerWagerMutation = svs.components.tipsen.store.tipsenApi.useExaminePlayerWagerMutation;
const useBestBetRows = svs.components.poolBetting.bestBetRows.hooks.useBestBetRows;
const logger = getLogger('pool-betting:use-examine-player-wager');
const MAX_RETRIES = 5;
const ONE_SECOND = 1000;
const useExaminePlayerWager = _ref => {
  let examined = _ref.examined,
    isDrawFinalized = _ref.isDrawFinalized,
    productId = _ref.productId,
    wagerId = _ref.wagerId,
    drawNumber = _ref.drawNumber;
  const _useExaminePlayerWage = useExaminePlayerWagerMutation(),
    _useExaminePlayerWage2 = _slicedToArray(_useExaminePlayerWage, 2),
    examineWagerMutation = _useExaminePlayerWage2[0],
    _useExaminePlayerWage3 = _useExaminePlayerWage2[1],
    status = _useExaminePlayerWage3 === void 0 ? {} : _useExaminePlayerWage3;
  const _useBestBetRows = useBestBetRows(),
    isMaskedOutcomesInitialized = _useBestBetRows.isInitialized,
    maskedOutcomes = _useBestBetRows.maskedOutcomes;
  const _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    retryCount = _React$useState2[0],
    setRetryCount = _React$useState2[1];
  const error = status.error;
  useEffect(() => {
    if (examined !== false || !isDrawFinalized || !drawNumber) {
      return;
    }
    if (isMaskedOutcomesInitialized && maskedOutcomes.length === 0) {
      if (retryCount >= MAX_RETRIES) {
        logger.error("Examine wager failed after ".concat(MAX_RETRIES, " retries"));
        logger.error('Error message:', error === null || error === void 0 ? void 0 : error.message);
        return;
      }
      const retryWithDelay = setTimeout(async () => {
        try {
          await examineWagerMutation({
            productId,
            wagerId,
            drawNumber
          }).unwrap();
          setRetryCount(0);
        } catch (err) {
          logger.warn('Examine wager failed:', err === null || err === void 0 ? void 0 : err.message);
          setRetryCount(prevCount => prevCount + 1);
        }
      }, ONE_SECOND);
      return () => clearTimeout(retryWithDelay);
    }
  }, [drawNumber, error === null || error === void 0 ? void 0 : error.message, examineWagerMutation, examined, isDrawFinalized, isMaskedOutcomesInitialized, maskedOutcomes === null || maskedOutcomes === void 0 ? void 0 : maskedOutcomes.length, productId, retryCount, wagerId]);
};
setGlobal('svs.components.poolBetting.hooks.useExaminePlayerWager', useExaminePlayerWager);

 })(window);